export default "__VITE_ASSET__Db6DgXB8__"